export const buttonColorOptions = ["white", "dark", "gray", "purple", "teal"];

export const buttonColorOrderGrayBackground = ["purple", "teal", "dark"];

export const buttonColorOrderImageHero = ["white", "teal", "dark"];

export const buttonColorOrderImageHeroDark = ["white", "purple", "teal"];

export const buttonColorDefault = "purple";
